import {
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type
} from "./../ricos-schema/legacy/wix/rich_content/v1";
const DEFAULTS = Object.freeze({
  config: {
    alignment: "center",
    size: "content",
    showTitle: true,
    showDescription: true
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    textWrap: true
  }
});
const imageModals = {
  settings: `${Node_Type.IMAGE}.settings`,
  imageEditor: `${Node_Type.IMAGE}.imageEditor`
};
const IMAGE_BUTTONS = {
  size: `${Node_Type.IMAGE}.size`,
  alignment: `${Node_Type.IMAGE}.alignment`
};
export {
  DEFAULTS,
  IMAGE_BUTTONS,
  RICOS_DEFAULTS,
  imageModals
};
//# sourceMappingURL=consts.js.map
